import { TextField, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { useAppDispatch } from "../../../app/hooks";
import FormSaveCancelButtons from "../../../common/components/functional/formSaveCancelButtons/FormSaveCancelButtons";
import { Talent } from "../../talents/talentAPI";
import { updateTalentAccountAddress } from "../../talents/talentsSlice";

type Props = {
  onClose: () => void;
  talent: Talent | null;
};

const TalentEditContactDetails = ({ onClose, talent }: Props) => {
  const account = talent?.account;

  const [talentAddress, setTalentAddress] = useState({
    street: account?.address?.street || "",
    zip: account?.address?.zip || "",
    city: account?.address?.city || "",
    country: "FI",
  });

  const dispatch = useAppDispatch();
  const { t } = useTranslation("talentProfile");
  const { talentId } = useParams();

  const fields = [
    {
      name: "street",
      label: t("address"),
      value: talentAddress.street,
    },
    {
      name: "zip",
      label: t("zipCode"),
      value: talentAddress.zip,
    },
    {
      name: "city",
      label: t("city"),
      value: talentAddress.city,
    },
    {
      name: "country",
      value: "FI",
      disabled: true,
    },
  ];

  const onSubmit = () => {
    if (talentId) {
      dispatch(updateTalentAccountAddress({ talentAddress, talentId }));
      onClose();
    }
  };

  const onChange = ({ name, value }: { name: string; value: string }) =>
    setTalentAddress({ ...talentAddress, [name]: value });

  // TODO: refactor to use FormContainer and react-hook-form
  return (
    <form>
      <Typography mb={1} variant="h6" component="h2">
        {t("contactDetails")}
      </Typography>
      {fields.map((field) => (
        <TextField
          sx={{ margin: "0.5rem 0" }}
          key={field.label}
          name={field.name}
          value={field.value}
          label={field.label}
          disabled={field.disabled}
          fullWidth
          onChange={(e) => onChange(e.target)}
        />
      ))}
      <FormSaveCancelButtons onSubmit={onSubmit} onClose={onClose} />
    </form>
  );
};

export default TalentEditContactDetails;
